import Repository from "../../repository/Repository";

export default class ChannelsService {
  #endpoint;
  #repository;

  constructor() {
    this.#endpoint = "/channels";
    this.#repository = new Repository();
  }

  //TODO ENDPOINT URL
  async getChannelsData(getContactsParams) {
    try {
      const { token, signal } = getContactsParams;

      const endpoint = '/v1/omuni-channels/channels';

      const apiToken = token;

      const data = await this.#repository.get({
        endpoint,
        apiToken,
        signal,
        useGateway: true
      });

      return Promise.resolve(data);
    } catch (error) {
      return Promise.reject(error);
    }
  }
  async createConnection(createConnectionParams) {
    try {
      const { information, token, signal } = createConnectionParams;

      const endpoint = `${this.#endpoint}/connection`;

      const data = await this.#repository.post({
        endpoint,
        information,
        token,
        signal,
      });

      return Promise.resolve(data);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async removeConnection(removeConnectionParams) {
    const { information, token, signal } = removeConnectionParams;

    const endpoint = `${this.#endpoint}/connection/${information.id}`;

    const data = await this.#repository.delete({
      endpoint,
      token,
      signal,
    });

    return Promise.resolve(data);
  }
  catch(error) {
    return Promise.reject(error);
  }

  async validateConnectionId(createConnectionParams) {
    try {
      const { connectionId, token, signal } = createConnectionParams;

      const endpoint = `${this.#endpoint}/connection-id-available/${connectionId}`;

      const data = await this.#repository.get({
        endpoint,
        token,
        signal,
      });

      return Promise.resolve(data);
    } catch (error) {
      return Promise.reject(error);
    }
  }
}
